'use client';
import Image from 'next/image';
import {Village} from '@/services/types';
import {IVillageDictionary} from '@/dictionaries/pages/village/types';
import getMediaFilterUrl from '@/utils/get-media-filter';

type Props = {
  handleOpenModal: () => void;
  village: Village;
  villageDict: IVillageDictionary;
};

export default function GalleryModalTrigger({
  handleOpenModal,
  village,
  villageDict,
}: Props) {
  const galleryMedia = village.media.filter((file) => file.type === 'gallery');
  const galleryCover = `${galleryMedia[0]?.path}${galleryMedia[0]?.filename}`;

  const filteredGalleryCover = getMediaFilterUrl({
    mediaFilters: galleryMedia[0]?.mediaFilters,
    filterName: '1920w_webp',
  });

  return (
    <div
      onClick={handleOpenModal}
      className="h-[50%] w-full flex-[0_0_auto] cursor-pointer flex flex-col">
      <div className="mt-auto h-[calc(30vh-15px)] min-h-[260px] max-h-[900px] relative">
        <Image
          src={
            filteredGalleryCover ??
            `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/large_3-2_webp/${galleryCover}`
          }
          alt="Photo cover villa"
          width={100}
          height={100}
          className="opacity-100 transition-all duration-300 ease-in-out w-full h-full object-cover object-[50%_50%] inline-block align-middle max-w-full"
          sizes="(min-width: 1280px) 80vw, (min-width: 767px) 90vw, (min-width: 480px) 100vw, 100vw"
        />
        <div className="bg-[rgba(0,0,0,.2)] absolute top-0 left-0 w-full h-full p-[30px] flex flex-col items-center justify-center text-white">
          <div className="text-center">
            <h2 className="mb-0 text-4xl font-title leading-[1.25]">
              {galleryMedia.length} {villageDict.gallery.photos}
            </h2>
            <p className="mb-0 mt-8 text-center font-semibold uppercase leading-[1.7] tracking-[2px]">
              {villageDict.gallery.viewAll}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
